import "../../Style/Footer.scss";
import Logo from "../../Assets/Images/Footer/RBN-logo.png";
import { HashLink } from "react-router-hash-link";
function Footer() {
  return (
    <div className="Footer-Container">
      <div className="Footer-Wrapper">
        <div className="Footer-Top-Section">
          <div className="Top-Left-Section">
            <a href="/">
              <img
                className="image"
                src={
                  "https://res.cloudinary.com/doy2qixs5/image/upload/v1745494294/rbn/projects/logo/risjadson-land-logo.png"
                }
              />
            </a>
          </div>
          <div className="Top-Right-Section">
            <div className="About padding-20 d-flex-flex-column">
              <a href="/about">
                <p>ABOUT</p>
              </a>
              <HashLink to={"/about#risjadsonland"}>
                <span>Risjadson Land</span>
              </HashLink>
              <HashLink to={"/about#risjadcon"}>
                <span>RCON</span>
              </HashLink>
              <HashLink to={"/about#risjadsonbt"}>
                <span>RiBT</span>
              </HashLink>
              {/* <HashLink to={"/about#rbm"}>
                <span>RBP</span>
              </HashLink> */}
            </div>

            <div className="Profile padding-20 d-flex-flex-column">
              <a href="/who" className="fixed">
                <p>WHO</p>
              </a>
              <HashLink to={"/who#Director"}>
                <span>Director</span>
              </HashLink>
              <HashLink to={"/who#Comm"}>
                <span>Commisioners</span>
              </HashLink>
            </div>
            <div className="Portofolio padding-20 d-flex-flex-column">
              <a href="/our-technology">
                <p>OUR TECHNOLOGY</p>
              </a>
              <HashLink to={"/our-technology#ourfactory"}>
                <span>Our Factory</span>
              </HashLink>
              <HashLink to={"/our-technology#wwo"}>
                <span>What We Offer</span>
              </HashLink>
            </div>
            <div className="Partner padding-20 d-flex-flex-column">
              <a href="/experience">
                <p>EXPERIENCE</p>
              </a>
              <HashLink to={"/projects#Indonesia"}>
                <span>Indonesia</span>
              </HashLink>
              <HashLink to={"/projects#Philippines"}>
                <span>Philippines</span>
              </HashLink>
              <HashLink to={"/experience#Malaysia"}>
                <span>Malaysia</span>
              </HashLink>
              <HashLink to={"/experience#Australia"}>
                <span>Australia</span>
              </HashLink>
            </div>
          </div>
        </div>
        <div className="Footer-Bottom-Section">
          <div className="Left-Text-Section">
            <p>
              <span>
                Menara Batavia 30th Floor
                <span>
                  Jl. K.H. Mas Mansyur, Kav. 126 Jakarta 10250 Indonesia
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="Footer-Contact-Map-Section">
          <div className="Contact-Left">
            <p>
              <strong>General enquiries</strong>
            </p>
            <a href="mailto:contact@risjadsonland.com">
              contact@risjadsonland.com
            </a>

            <form className="Footer-Form">
              <input type="text" placeholder="Name" />
              <input type="email" placeholder="E-mail" />
              <textarea placeholder="Comments" rows="3" />
              <button type="submit">Submit</button>
            </form>
          </div>

          <div className="Map-Right">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d991.4896572212523!2d106.81494280000001!3d-6.2107227!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f6aa0ce995f9%3A0xed935b94a739c157!2sMenara%20Batavia!5e0!3m2!1sen!2sid!4v1680674304872!5m2!1sen!2sid"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Office Location"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
